import { render, staticRenderFns } from "./FieldCustomerDeliveryTermsAccept.vue?vue&type=template&id=60dc3a71&scoped=true&"
import script from "./FieldCustomerDeliveryTermsAccept.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerDeliveryTermsAccept.vue?vue&type=script&lang=js&"
import style0 from "./FieldCustomerDeliveryTermsAccept.vue?vue&type=style&index=0&id=60dc3a71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc3a71",
  null
  
)

export default component.exports